import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of, tap } from 'rxjs';

import { environment } from '../../../environments/environment';
import { TurnstileVerifyResponse } from '../../models/turnstile-verification.model';

/**
 * Singleton. Orquesta la verificacion server-side de un token de Cloudflare
 * Turnstile: manda el token al backend (POST /api/turnstile/verify -- ruta
 * PUBLICA a proposito, ver modules/09-it-reinvent-viajes-apigateway-infra/
 * main.tf) y expone `verified`/`error` como signals para que AppComponent
 * decida si mostrar el shell completo o el gate (ver app.component.html).
 * Mismo patron HttpClient + RxJS que ContactConfigService.
 */
@Injectable({ providedIn: 'root' })
export class TurnstileVerificationService {
  readonly verified = signal(false);
  readonly error = signal(false);

  constructor(private readonly http: HttpClient) {}

  verifyToken(token: string): void {
    this.error.set(false);
    this.http
      .post<TurnstileVerifyResponse>(`${environment.apiBaseUrl}/turnstile/verify`, { token })
      .pipe(
        tap((result) => {
          if (result.success) {
            this.verified.set(true);
          } else {
            this.error.set(true);
          }
        }),
        catchError(() => {
          this.error.set(true);
          return of(null);
        }),
      )
      .subscribe();
  }

  /** El widget de Turnstile fallo del lado del cliente (error-callback). */
  reportClientError(): void {
    this.error.set(true);
  }

  /** El token expiro (expired-callback) -- hay que volver a mostrar el gate. */
  reset(): void {
    this.verified.set(false);
  }
}
